import { z } from 'zod';
import { AdminActionInput } from '../shared.js';
// ── appeals (FR-ADM-27, FR-SET-09) ────────────────────────────────────────
export const AppealInput = z.object({ statement: z.string().trim().min(20).max(2_000) });
export const AppealView = z.object({
    id: z.string(),
    memberId: z.string(),
    statement: z.string(),
    sanctionReason: z.string().nullable(),
    imposedBy: z.string().nullable(),
    state: z.enum(['pending', 'upheld', 'overturned']),
    decisionReason: z.string().nullable(),
    createdAt: z.coerce.date(),
});
export const AppealDecideInput = AdminActionInput.extend({ overturn: z.boolean() });
//# sourceMappingURL=schemas.js.map